<template>
  <v-container fluid>
    <v-card>
      <v-toolbar flat>
        <v-text-field hide-details outlined clearable placeholder="Search" dense v-model="search"></v-text-field>
        <v-btn class="ml-3 box-shadow" color="primary" @click="create_item_dialog = !create_item_dialog">Create new</v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-data-table :headers="table_data.headers"
                    :items="table_data.items"
                    :search="search">
        <template v-slot:item.p1_exam_dates="{ value }">
          <template v-for="(item) in value">
            {{ $moment(item).format('DD/MM/YYYY') }},
          </template>
        </template>

        <template v-slot:item.p2_exam_dates="{ value }">
          <template v-for="(item) in value">
            {{ $moment(item).format('DD/MM/YYYY') }},
          </template>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2" @click="openSelectedItemDialog(item)">mdi-pencil</v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="create_item_dialog" max-width="500px">
      <v-form class="text-center" @submit="createItem">
        <v-card class="box-shadow">
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeCreateItemDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Create</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text type="submit" color="success">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-text-field
                v-model="new_item.name"
                label="Name"
                :error-messages="api_errors['name']"
                required
            />

            <dates-field v-model="new_item.p1_exam_dates" label="P1 exam dates"/>
            <dates-field v-model="new_item.p2_exam_dates" label="P2 exam dates"/>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="selected_item_dialog" max-width="500px">
      <v-form v-if="selected_item" @submit="updateSelectedItem">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeSelectedItemDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Settings</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text type="submit">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-text-field
                v-model="selected_item.name"
                label="Name"
                :error-messages="api_errors['name']"
                required
            />

            <dates-field v-model="selected_item.p1_exam_dates" label="P1 exam dates"/>
            <dates-field v-model="selected_item.p2_exam_dates" label="P2 exam dates"/>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

  </v-container>
</template>

<script>
import DatesField from "../../../components/DatesField";
export default {
  components: {DatesField},
  props: {
    study_group: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    table_data: {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'OSCE P1', value: 'p1_exam_dates' },
        { text: 'OSCE P2', value: 'p2_exam_dates' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: []
    },
    search: '',
    create_item_dialog: false,
    new_item: {
      name: '',
      p1_exam_dates: [],
      p2_exam_dates: [],
    },
    selected_item_dialog: false,
    selected_item: null,
    api_errors: []
  }),
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      let url = `api/study-groups/${this.$route.params.study_group_id}/study-sub-groups`
      this.table_data.items = await this.axios.get(url)
          .then(({data}) => data.data)
    },
    closeCreateItemDialog() {
      this.create_item_dialog = false;
      this.new_item = {
        name: '',
        p1_exam_dates: [],
        p2_exam_dates: [],
      }
    },
    createItem(e) {
      e.preventDefault()
      this.api_errors = []
      let url = `api/study-groups/${this.$route.params.study_group_id}/study-sub-groups`
      this.axios.post(url, {
        name: this.new_item.name,
        p1_exam_dates: this.new_item.p1_exam_dates,
        p2_exam_dates: this.new_item.p2_exam_dates,
      })
          .then(({data}) => {
            this.table_data.items.unshift(data.data)
            this.closeCreateItemDialog()
          })
          .catch(({response}) => { this.api_errors = response.data.errors })
    },
    openSelectedItemDialog(item) {
      this.selected_item = item
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
    },
    updateSelectedItem(e) {
      e.preventDefault()
      this.api_errors = []
      let url = `api/study-groups/${this.$route.params.study_group_id}/study-sub-groups/${this.selected_item.id}`
      this.axios.put(url, {
        name: this.selected_item.name,
        p1_exam_dates: this.selected_item.p1_exam_dates,
        p2_exam_dates: this.selected_item.p2_exam_dates,
      })
          .then(() => {
            this.loadData()
            this.closeSelectedItemDialog()
          })
          .catch(({response}) => { this.api_errors = response.data.errors })
    },
  }
}
</script>